import React, { useContext } from 'react';
import { number, bool } from 'prop-types';

import { getDepositFormatted } from '../../utils/pricing-helper';
import { ToolContext } from '../../context/tool-context';

import './deposit-callout.scss';

export const DepositCallout = ({ depositAmount, depositCalloutReduced }) => {
  const tool = useContext(ToolContext);
  const isAVehicle = tool.isAVehicle();

  const toggleType = isAVehicle ? 'vehicle' : 'tool';
  const toggleIdentification = isAVehicle ? 'Driver\'s License and Proof of Insurance' : 'identification';

  return (
    <div className="rental-deposit--copy">
      {depositCalloutReduced
        ? (
          <div>
            <div className="deposit-amount">{getDepositFormatted(depositAmount)} Deposit or Credit
              Card hold may be required.
            </div>
            <div>Credit Cards accepted. No Cash.</div>
          </div>
        )
        : (
          <ul className="deposit-copy-list">
            <li className="deposit-amount">
              {getDepositFormatted(depositAmount)} Deposit or Credit Card hold may be required.
              Credit Cards accepted. No Cash.
            </li>
            <li>A <b>valid {toggleIdentification}</b> is required at pickup.</li>
            {isAVehicle
              ? (
                <>
                  <li>Customers are responsible for <b>refueling vehicle</b>.</li>
                  <li>Vehicles must be returned to the <b>same pickup location</b>.</li>
                </>
              )
              : <li>This tool may require accessories.</li>}
          </ul>
        )}
    </div>
  );
};

DepositCallout.displayName = 'DepositCallout';

DepositCallout.propTypes = {
  depositAmount: number.isRequired,
  depositCalloutReduced: bool.isRequired
};
